export const USERS_GET_LIST = "USERS_GET_LIST";
export const USERS_GET_LIST_SUCCESS = "USERS_GET_LIST_SUCCESS";
export const USERS_GET_LIST_FAILED = "USERS_GET_LIST_FAILED";

export const USER_GET_STATUS_BUCKET = "USER_GET_STATUS_BUCKET";
export const USER_GET_STATUS_BUCKET_SUCCESS = "USER_GET_STATUS_BUCKET_SUCCESS";
export const USER_GET_STATUS_BUCKET_FAILED = "USER_GET_STATUS_BUCKET_FAILED";

export const USER_GET_ASSIGN_USER = "USER_GET_ASSIGN_USER";
export const USER_GET_ASSIGN_USER_SUCCESS = "USER_GET_ASSIGN_USER_SUCCESS";
export const USER_GET_ASSIGN_USER_FAILED = "USER_GET_ASSIGN_USER_FAILED";

export const GET_ASSIGN_LEGAL_EXECUTIVE = "GET_ASSIGN_LEGAL_EXECUTIVE";
export const GET_ASSIGN_LEGAL_EXECUTIVE_SUCCESS = "GET_ASSIGN_LEGAL_EXECUTIVE_SUCCESS";
export const GET_ASSIGN_LEGAL_EXECUTIVE_FAILED = "GET_ASSIGN_LEGAL_EXECUTIVE_FAILED";

export const GET_INTERNAL_LEGAL_EXPERT = "GET_INTERNAL_LEGAL_EXPERT";
export const GET_INTERNAL_LEGAL_EXPERT_SUCCESS = "GET_INTERNAL_LEGAL_EXPERT_SUCCESS";
export const GET_INTERNAL_LEGAL_EXPERT_FAILED = "GET_INTERNAL_LEGAL_EXPERT_FAILED";

export const USER_GET_LEGAL_SUBEXECUTIVE = "USER_GET_LEGAL_SUBEXECUTIVE";
export const USER_GET_LEGAL_SUBEXECUTIVE_SUCCESS = "USER_GET_LEGAL_SUBEXECUTIVE_SUCCESS";
export const USER_GET_LEGAL_SUBEXECUTIVE_FAILED = "USER_GET_LEGAL_SUBEXECUTIVE_FAILED";

export const USER_UPDATE_USER_SUCCESS = "USER_UPDATE_USER_SUCCESS";
export const USER_UPDATE_USER_FAILED = "USER_UPDATE_USER_FAILED";

export const USER_ADD_USER_SUCCESS = "USER_ADD_USER_SUCCESS";
export const USER_ADD_USER_FAILED = "USER_ADD_USER_FAILED";

export const USER_UPDATE_PASSWORD = "USER_UPDATE_PASSWORD";
export const USER_UPDATE_PASSWORD_SUCCESS = "USER_UPDATE_PASSWORD_SUCCESS";
export const USER_UPDATE_PASSWORD_FAILED = "USER_UPDATE_PASSWORD_FAILED";

export const GET_PARTNER_USERS = "GET_PARTNER_USERS";
export const GET_PARTNER_USERS_SUCCESS = "USER_UPDAGET_PARTNER_USERS_SUCCESSTE_PASSWORD";
export const GET_PARTNER_USERS_FAILED = "GET_PARTNER_USERS_FAILED";

export const GET_PARTNER_USERS_REPORT = "GET_PARTNER_USERS_REPORT";
export const GET_PARTNER_USERS_REPORT_SUCCESS = "GET_PARTNER_USERS_REPORT_SUCCESS";
export const GET_PARTNER_USERS_REPORT_FAILED = "GET_PARTNER_USERS_REPORT_FAILED";

export const GET_SINGLE_PARTNER_USER = "GET_SINGLE_PARTNER_USER";
export const GET_SINGLE_PARTNER_USER_SUCCESS = "GET_SINGLE_PARTNER_USER_SUCCESS";
export const GET_SINGLE_PARTNER_USER_FAILED = "GET_SINGLE_PARTNER_USER_FAILED";

export const ADD_USER_FOLLOW_UP = "ADD_USER_FOLLOW_UP";
export const ADD_USER_FOLLOW_UP_SUCCESS = "ADD_USER_FOLLOW_UP_SUCCESS";
export const ADD_USER_FOLLOW_UP_FAILED = "ADD_USER_FOLLOW_UP_FAILED";

export const CHANGE_PARTNER_USER = "CHANGE_PARTNER_USER";
export const CHANGE_PARTNER_USER_SUCCESS = "CHANGE_PARTNER_USER_SUCCESS";
export const CHANGE_PARTNER_USER_FAILED = "CHANGE_PARTNER_USER_FAILED";

export const GET_EXECUTIVE_NAME = "GET_EXECUTIVE_NAME";
export const GET_EXECUTIVE_NAME_SUCCESS = "GET_EXECUTIVE_NAME_SUCCESS";
export const GET_EXECUTIVE_NAME_FAILED = "GET_EXECUTIVE_NAME_FAILED";

export const GET_DAILY_TASK_LIST = "GET_DAILY_TASK_LIST";
export const GET_DAILY_TASK_LIST_SUCCESS = "GET_DAILY_TASK_LIST_SUCCESS";
export const GET_DAILY_TASK_LIST_FAILED = "GET_DAILY_TASK_LIST_FAILED";

export const UPLOAD_RECORDING = "UPLOAD_RECORDING";
export const UPLOAD_RECORDING_SUCCESS = "UPLOAD_RECORDING_SUCCESS";
export const UPLOAD_RECORDING_FAILED = "UPLOAD_RECORDING_FAILED";

export const GET_PARTNER_CASES = "GET_PARTNER_CASES";
export const GET_PARTNER_CASES_SUCCESS = "GET_PARTNER_CASES_SUCCESS";
export const GET_PARTNER_CASES_FAILED = "GET_PARTNER_CASES_FAILED";

export const DOWNLOAD_DAILY_TASK = "DOWNLOAD_DAILY_TASK";
export const DOWNLOAD_DAILY_TASK_SUCCESS = "DOWNLOAD_DAILY_TASK_SUCCESS";
export const DOWNLOAD_DAILY_TASK_FAILED = "DOWNLOAD_DAILY_TASK_FAILED";